import styled from "styled-components";
import {colors} from "nxtconstants";

export const CalculatorSection = styled.section`
  padding: 3rem 0;
  background-color: ${colors.white};
  font-family: "Lato";

  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;

export const PageTitle = styled.h1`
  font-size: 4.2rem;
  font-family: "DM Serif Display";
  font-weight: 400;
  color: ${colors.textBlack};
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 4rem;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    line-height: 1.2;
    width: 85%;
    margin: 0 auto 2rem;
    padding: 0;
  }
`;

export const MobileTabContainer = styled.div`
  display: none;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 2rem;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  background: ${colors.white};

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MobileTabButton = styled.button`
  flex: 1;
  border: none;
  cursor: pointer;
  padding: 1.2rem 1.6rem;
  font-family: "Lato";
  font-size: 1.6rem;
  font-weight: 600;
  background: ${(props) => (props.active ? colors.secondary : colors.white)};
  color: ${(props) => (props.active ? colors.textBlack : colors.textGray)};
  transition: background 0.2s ease;

  &:not(:last-child) {
    border-right: 1px solid ${colors.lightGray};
  }
`;

export const CalculatorWrapper = styled.div`
  display: grid;
  grid-template-columns: 50rem 1fr;
  gap: 6rem;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;
  align-items: start;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  border-radius: 2rem;
  padding: 4rem;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
    gap: 0;
    width: 85%;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
  }
`;

export const ControlPanel = styled.div`
  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const ResultsPanel = styled.div`
  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const SummaryBar = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 2rem;
  background-color: ${colors.secondary};
  padding: 2rem 2.8rem;
  border-radius: 1.2rem;
  margin-bottom: 1.6rem;
  min-width: 0;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 1.6rem;
    padding: 2rem;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileSummaryCard = styled.div`
  display: none;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileSummaryHighlight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  background-color: ${colors.secondary};
  padding: 1.6rem 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  color: ${colors.textBlack};

  span:first-child {
    flex-shrink: 0;
    max-width: 45%;
  }

  span:last-child {
    min-width: 0;
    text-align: right;
    word-break: break-word;
  }
`;

export const MobileSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.4rem 2rem;
  font-size: 1.6rem;
  color: ${colors.textBlack};
  background: ${colors.white};
  border-top: 1px solid ${colors.lightGray};

  span:first-child {
    flex-shrink: 0;
    max-width: 45%;
  }

  span:last-child {
    font-weight: 400;
    min-width: 0;
    text-align: right;
    word-break: break-word;
  }
`;

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
`;

export const SummaryLabel = styled.span`
  font-size: 1.8rem;
  color: ${colors.textGray};
  word-break: break-word;
`;

export const SummaryValue = styled.span`
  font-size: 2rem;
  color: ${(props) => (props.variant === "gain" ? "#16a34a" : colors.textBlack)};
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export {ViewToggleButton, ViewToggleContainer} from "../ViewToggleStyles";

export const ChartContainer = styled.div`
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    margin: 0 -0.8rem;
    overflow-x: auto;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: "Lato";
  font-size: 1.4rem;

  th,
  td {
    padding: 1.2rem 1rem;
    text-align: right;
    border-bottom: 1px solid ${colors.lightGray};
    white-space: nowrap;
  }

  th:first-child,
  td:first-child {
    text-align: left;
  }

  th {
    color: ${colors.textGray};
    font-weight: 500;
    background: #fafafa;
  }

  td {
    color: ${colors.textBlack};
  }
`;

export const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2.4rem;
  padding-top: 1.5rem;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
`;

export const LegendSwatch = styled.div`
  width: 3rem;
  height: 0.5rem;
  background-color: ${(props) => props.color};
  border-radius: 0.6rem;

  @media (max-width: 768px) {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
`;

export const LegendLabel = styled.span`
  margin-left: 1rem;
  font-size: 1.6rem;
  font-family: "Lato";
  color: ${colors.textGray};
`;

export const TooltipTotalRow = styled.p`
  color: #111827;
  margin: 0.8rem 0 0;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;
